import { isLocationPageType } from '@/domain/useCases/pageTypeCheck'
import { Center } from '@/types/models'
import { useState, useMemo } from 'react'
import { PageType } from '@/types/models/PageType.model'

const MINIMUM_CENTER_COUNT = 3

export default function useRenderFeaturedSUDCenters({
  isLoading,
  centers = [],
  pageType,
  showFeaturedCenters
}: {
  isLoading: boolean
  centers: Center[]
  pageType: PageType
  showFeaturedCenters: boolean
}): { shouldRenderFeaturedSUDCenters: boolean } {
  const [shouldRenderFeaturedSUDCenters, setShouldRenderFeaturedSUDCenters] =
    useState(true)

  useMemo(() => {
    setShouldRenderFeaturedSUDCenters(
      isLocationPageType(pageType) &&
        (isLoading || centers.length > MINIMUM_CENTER_COUNT) &&
        showFeaturedCenters
    )
  }, [isLoading, centers])

  return {
    shouldRenderFeaturedSUDCenters
  }
}
